import type { OperationTypeDefinition, Archetype } from '@/graph/domain/types';

export interface CatalogFilterOptions {
  archetypes: Archetype[];
  searchQuery?: string;
}

export function filterCatalog(
  entries: OperationTypeDefinition[],
  options: CatalogFilterOptions,
): OperationTypeDefinition[] {
  return entries.filter((entry) => {
    if (entry.isArchived) return false;
    if (entry.isSoftDeleted) return false;
    if (!entry.display) return false;
    if (!entry.isCurrentVersion) return false;
    if (entry.operationType === null) return false;
    if (!options.archetypes.includes(entry.operationType)) return false;

    if (options.searchQuery) {
      const q = options.searchQuery.toLowerCase().trim();
      if (!q) return true;
      const haystack = [entry.operationName, entry.uid].join(' ').toLowerCase();
      if (!haystack.includes(q)) return false;
    }

    return true;
  });
}
